import React from 'react';

import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

import card1p from '../assets/4typesCard1.png';
import card2p from '../assets/4typesCard2.png';
import card3p from '../assets/4typesCard3.png';
import card4p from '../assets/4typesCard4.png';

const useStyles = makeStyles((theme) => ({
  wrapper: { marginTop: '3.125rem' },
  container: {
    width: '100vw',
    background: 'linear-gradient(#FECCF4, #FBC143)',
    paddingBottom: '1.5rem'
  },
  cardNumber: {
    fontFamily: 'proximaNovaB',
    color: '#3E47E9',
    fontSize: '.8rem',
    textAlign: 'left',
    marginBottom: '1.5rem'
  },
  cardTitle: {
    fontFamily: 'Cormorant Garamond, serif',
    fontSize: '2.1rem',
    fontWeight: '400',
    width: '226px',
    textAlign: 'left',
    lineHeight: '2.3rem',
    marginBottom: '40px'
  },
  paragraph: {
    fontFamily: 'proximaNovaReg',
    lineHeight: '24px',
    textAlign: 'left',
    marginBottom: '40px'
  },
  span: {
    fontFamily: 'proximaNovaB',
    fontSize: '1.125rem'
  }
}));

const FourTypesCarousel = () => {
  const classes = useStyles();

  const indicatorStyles = {
    background: '#fff',
    width: 12,
    height: 12,
    borderRadius: '50%',
    display: 'inline-block',
    margin: '0 8px'
  };

  return (
    <Grid container justifyContent="center" className={classes.wrapper}>
      <Grid item className={classes.container}>
        <Carousel
          showThumbs={false}
          showArrows={false}
          showStatus={false}
          // showIndicators={true}
          swipeable={true}
          renderIndicator={(onClickHandler, isSelected, index, label) => {
            if (isSelected) {
              return (
                <li
                  style={{ ...indicatorStyles, background: '#3E47E9' }}
                  aria-label={`Selected: ${label} ${index + 1}`}
                  title={`Selected: ${label} ${index + 1}`}
                />
              );
            }
            return (
              <li
                style={indicatorStyles}
                onClick={onClickHandler}
                onKeyDown={onClickHandler}
                value={index}
                key={index}
                role="button"
                tabIndex={0}
                title={`${label} ${index + 1}`}
                aria-label={`${label} ${index + 1}`}
              />
            );
          }}
        >
          <div>
            <img src={card1p} alt="card with breast cancer info" style={{ padding: '2.5rem' }} />
          </div>
          <div>
            <img src={card2p} alt="card with breast cancer info" style={{ padding: '2.5rem' }} />
          </div>
          <div>
            <img src={card3p} alt="card with breast cancer info" style={{ padding: '2.5rem' }} />
          </div>
          <div>
            <img src={card4p} alt="card with breast cancer info" style={{ padding: '2.5rem' }} />
          </div>
          {/* <div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-start',
                padding: '2rem',
                flexDirection: 'column'
              }}
            >
              <h6 className={classes.cardNumber}>01 / 04</h6>
              <h1 className={classes.cardTitle}>4 Types of Breast Cancer</h1>
              <p className={classes.paragraph}>
                <span className={classes.span}>Invasive Ductal Carcinoma (IDC): </span>
                <br />
                An invasive cancer where cancer cells initially formed in the milk ducts have spread
                into other parts of the breast tissue. This is the most common type of breast
                cancer, making up between 70 and 80% of diagnoses.
              </p>
            </div>
          </div>
          <div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-start',
                padding: '2rem',
                flexDirection: 'column'
              }}
            >
              <h6 className={classes.cardNumber}>02 / 04</h6>
              <h1 className={classes.cardTitle}>4 Types of Breast Cancer</h1>
              <p className={classes.paragraph}>
                <span className={classes.span}>Triple-negative Breast Cancer (TNBC):</span>
                <br />
                Estrogen, progesterone, and the HER-2/neu gene are the three most common receptors
                known to feed breast cancer growth. A diagnosis of triple-negative breast cancer
                means that the cancer cells have tested negative for these receptors, making it very
                difficult to treat. TNBC accounts for 15 to 20% of diagnoses. This type of breast
                cancer is also more deadly for Black women, with a low, 14% 5-year relative survival
                rate based on NIH reports.
              </p>
            </div>
          </div>
          <div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-start',
                padding: '2rem',
                flexDirection: 'column'
              }}
            >
              <h6 className={classes.cardNumber}>03 / 04</h6>
              <h1 className={classes.cardTitle}>4 Types of Breast Cancer</h1>
              <p className={classes.paragraph}>
                <span className={classes.span}>Inflammatory Breast Cancer (IBC):</span>
                <br />
                This type of breast cancer is an aggressive and rapidly-growing cancer in which
                cancer cells penetrate the skin and lymph vessels of the breast, often producing no
                distinct tumor or lump that can be felt within the breast. Symptoms begin to appear
                when the lymph vessels become blocked by the breast cancer cells, which can cause
                skin irritation with persistent itching and appearance similar to a bug bite. In
                other cases, the breast can become red and swollen, with the skin taking on a pitted
                “orange peel” like appearance, and can also cause changes to the nipple.
              </p>
            </div>
          </div>
          <div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-start',
                padding: '2rem',
                flexDirection: 'column'
              }}
            >
              <h6 className={classes.cardNumber}>04 / 04</h6>
              <h1 className={classes.cardTitle}>4 Types of Breast Cancer</h1>
              <p className={classes.paragraph}>
                <span className={classes.span}>Metastatic Breast Cancer:</span>
                <br />
                Also known as Stage 4 cancer, this type indicates the spread of cancer cells to the
                rest of the body, like the lungs, liver, bones, or the brain. This stage of cancer
                spreads due to the cancer cells invading nearby healthy cells, migrating through the
                bloodstream to other parts of the body, or via new tumor growth, to name a few
                steps.
              </p>
            </div>
          </div> */}
        </Carousel>
      </Grid>
    </Grid>
  );
};

export default FourTypesCarousel;
